import request from '@/utils/request'
export function getMessage(query) {
    return request({
        url: '/oauth/server-exam/message/list2',
        method: 'get',
        params: query
    })
}
export function getMessageDetail(id) {
    return request({
        url: '/oauth/server-exam/message/read/' + id,
        method: 'get'
    })
}
export function readMessage() {
    return request({
        url: '/oauth/server-exam/message/read',
        method: 'get'
    })
}
export function checkUnRead(query) {
    return request({
        url: '/oauth/server-messageCenter/messageCenter/checkUnRead',
        method: 'get',
        params: query
    })
}